/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './authManageNotifications.defs.js'
export { main as default } from './authManageNotifications.defs.js'
